import React, { useContext, useState, useEffect, useRef } from 'react';
import { AuthContext } from "../context/AuthContext.jsx";

const RoomStatusComplete = ({ item, isFinalStep, isPodium }) => {
	const { sessionInfo } = useContext(AuthContext);

	const totalScoreText = (() => {
		const n = Number(item?.totalScore);
		if (!Number.isFinite(n)) return "";

		const truncated = Math.trunc(n * 10) / 10;
		const intPart = Math.trunc(truncated);
		const decPart = Math.abs(truncated - intPart);

		return decPart > 0 ? truncated.toFixed(1) : String(intPart);
	})();

	return (
		<>
			{item.totalScore != null /*&& sessionInfo.scoresEnabled*/ ? (
				<div style={{ backgroundColor: "var(--user-item-score-bg)"}} className={`user-item-score d-flex flex-column align-items-center justify-content-center p-3 text-white`}>
					<span className={`lh-sm`}>{totalScoreText}</span>
					<small className="d-block fw-light fs-8 fs-lg-6 mt-n2">PUNTI</small>
				</div>
			) : <div className="user-item-score opacity-0"></div>}

			<div className="room-status-complete">
				<h5 className={`user-item-name fw-semibold d-flex flex-lg-column mb-0 text-uppercase`}>
					{item.avatarId ? 
						<img src={`/img/react-app/avatars/01/avatar-${item.avatarId}.png`} title={item.nickName || item.displayName} className={`user-avatar me-0 ${!isPodium ? "mb-lg-2 me-3 me-lg-0" : ""}`} />
						:
						""}
					<div className="user-item-name-text"> 
						<div className="fw-bold">{item.nickName || item.displayName}</div>
						{item.instituteName ?
							<div className="school-name fs-9 d-none d-sm-block d-md-none d-lg-block">{item.instituteName}</div>
							:
							""
						}
					</div>
				</h5>
			</div>
		</>
	)
}

export default RoomStatusComplete;
